/** Datos del dispositivo para la consola de depuración y los informes de los spikes. */
export interface EnvironmentReport {
  userAgent: string
  standalone: boolean
  screen: string
  viewport: string
  devicePixelRatio: number
  serviceWorker: boolean
  wakeLock: boolean
  audioContext: boolean
  online: boolean
}

export function isStandalone(): boolean {
  const iosStandalone = (navigator as Navigator & { standalone?: boolean }).standalone === true
  return iosStandalone || window.matchMedia('(display-mode: standalone)').matches
}

export function environmentReport(): EnvironmentReport {
  return {
    userAgent: navigator.userAgent,
    standalone: isStandalone(),
    screen: `${screen.width}×${screen.height}`,
    viewport: `${window.innerWidth}×${window.innerHeight}`,
    devicePixelRatio: window.devicePixelRatio,
    serviceWorker: 'serviceWorker' in navigator,
    wakeLock: 'wakeLock' in navigator,
    audioContext: 'AudioContext' in window || 'webkitAudioContext' in window,
    online: navigator.onLine,
  }
}
